import React from "react";
import { useTranslation } from "react-i18next";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useAuth } from "utils/useAuth/useAuth";
import s from "./HeaderMenu.module.scss";

const HeaderMenu = () => {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const accountName = localStorage.getItem("account-name");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const menuStyle = {
    fontSize: "14px",
    fontFamily: "Noto Sans, Noto Sans HK, sans-serif",
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const signout = () => {
    logout("LOGOUT");
  };

  const menuItem = (title, fn) => {
    return (
      <MenuItem className={s.menuItem} onClick={fn} sx={menuStyle}>
        {title}
      </MenuItem>
    );
  };

  return (
    <div>
      <Button onClick={handleClick}>
        <AccountCircleIcon sx={{ color: "#666" }} />
        <div className={s.accountName}>{accountName}</div>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
        transitionDuration={200}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        {/* {generateMenuItem(t('layout.header.menu.profile'), logout)} */}
        {menuItem(t("layout.header.menuLogoutButton"), signout)}
      </Menu>
    </div>
  );
};

export default React.memo(HeaderMenu);
